import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

export function PromotionModalHeader({
  icon: Icon,
  title,
  subtitle,
  backTo,
  backState,
}) {
  return (
    <div className="bg-linear-to-b from-brand-50/40 to-white px-5 pt-5 sm:px-8 sm:pt-6">
      {backTo && (
        <Link
          to={backTo}
          state={backState}
          className="inline-flex cursor-pointer items-center gap-1.5 text-sm font-semibold text-slate-600 transition-colors hover:text-brand-700"
        >
          <ArrowLeft className="size-4" aria-hidden="true" />
          Back
        </Link>
      )}

      <div className={cn('text-center', backTo ? 'mt-4 sm:mt-6' : 'mt-0')}>
        <div className="inline-flex size-12 items-center justify-center rounded-2xl bg-brand-100 ring-2 ring-brand-200">
          <Icon className="size-6 text-brand-700" aria-hidden="true" />
        </div>
        <h1 className="mt-3 text-2xl font-extrabold tracking-tight text-slate-900 sm:text-3xl">
          {title}
        </h1>
        <p className="mt-2 text-sm text-slate-600 sm:text-base">{subtitle}</p>
      </div>
    </div>
  );
}